import React from 'react';
import { FlameIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { CORE_PRICE, SALE_PRICE } from '../data/content';
import { Reveal } from './Reveal';
const SPOTS_TAKEN = 72;
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex w-20 flex-col items-center border border-white/[0.07] bg-steel-900 px-3 py-3 sm:w-24" data-id="element-33" data-mp="39sdng6y5phlm">
      <span className="font-display text-4xl font-bold tabular-nums text-ember-400" data-id="element-34" data-mp="3nrd16jk4sc30">{value}</span>
      <span className="mt-1 text-[0.6rem] font-semibold uppercase tracking-[0.16em] text-ink-500" data-id="element-35" data-mp="3isa7fv9lpsac">
        {label}
      </span>
    </div>;
}
export function CountdownSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(23 * 3600 + 56 * 60 + 50);
  return <section className="w-full bg-steel-950 px-6 pb-4 pt-2 sm:pb-6" aria-labelledby="countdown-title" data-id="element-36" data-mp="ad8j0h9nrwet">
      <Reveal className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-37" data-mp="5exac9v3nry6">
        <h2 id="countdown-title" className="font-display text-3xl font-bold uppercase tracking-tight text-ink-50 sm:text-4xl" data-id="element-38" data-mp="1dm9ma8a8uwbd">
          Launch pricing ends soon
        </h2>

        <span className="mt-4 inline-flex items-center gap-2 border border-ember-500/40 bg-ember-500/10 px-3 py-1.5 text-[0.7rem] font-semibold uppercase tracking-[0.18em] text-ember-300" data-id="element-39" data-mp="1in74ulz61sde">
          <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-40" data-mp="1sklg8768fqyu" />
          ${SALE_PRICE} launch price · closes in
        </span>

        <div className="mt-6 flex justify-center gap-3" role="timer" aria-label={`${hours} hours, ${minutes} minutes and ${seconds} seconds left`} data-id="element-41" data-mp="21jyr94a08nlo">
          <TimeBlock value={hours} label="Hours" data-id="element-42" data-mp="26c05gvqqgoec" />
          <TimeBlock value={minutes} label="Min" data-id="element-43" data-mp="2b9iesn8nx5mv" />
          <TimeBlock value={seconds} label="Sec" data-id="element-44" data-mp="2b98n8v7yyqf2" />
        </div>

        <div className="mt-7 w-full max-w-md text-left" data-id="element-45" data-mp="2g9eggftw0kz9">
          <div className="flex items-baseline justify-between text-xs font-semibold uppercase tracking-[0.14em]" data-id="element-46" data-mp="2g6s31zkbfb94">
            <span className="text-ink-500" data-id="element-47" data-mp="l5pyw5fypxu7">Launch-price seats</span>
            <span className="text-ember-400" data-id="element-48" data-mp="l5yc5yfzz55x">{SPOTS_TAKEN}% claimed</span>
          </div>
          <div className="mt-2 h-1.5 w-full overflow-hidden bg-white/[0.08]" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={SPOTS_TAKEN} aria-label="Launch-price seats claimed" data-id="element-49" data-mp="g86jv3bfxh17">
            <div className="h-full bg-ember-500" style={{
            width: `${SPOTS_TAKEN}%`
          }} data-id="element-50" data-mp="p5qjy8xkh7a8" />
          </div>
          <p className="mt-2 text-xs text-ink-500" data-id="element-51" data-mp="13y0xhn3l39mi">
            After this window the price returns to ${CORE_PRICE} and does not come back down.
          </p>
        </div>
      </Reveal>
    </section>;
}